(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fWbcT", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf; }, function (v) { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b9a4f744ab95abc4$export$f7ad0328861e2f03; }, function (v) { return $b9a4f744ab95abc4$export$f7ad0328861e2f03 = v; });
var $b9a4f744ab95abc4$export$6503ec6e8aabbaf;
var $b9a4f744ab95abc4$export$f7ad0328861e2f03;
"use strict";
var $b9a4f744ab95abc4$var$mapping = new Map();
function $b9a4f744ab95abc4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b9a4f744ab95abc4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b9a4f744ab95abc4$var$resolve(id) {
    var resolved = $b9a4f744ab95abc4$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b9a4f744ab95abc4$export$6503ec6e8aabbaf = $b9a4f744ab95abc4$var$register;
$b9a4f744ab95abc4$export$f7ad0328861e2f03 = $b9a4f744ab95abc4$var$resolve;

});

parcelRegister("dOGL2", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a0f11cae5038e8ee$export$bdfd709ae4826697; }, function (v) { return $a0f11cae5038e8ee$export$bdfd709ae4826697 = v; });
var $a0f11cae5038e8ee$export$bdfd709ae4826697;
var $a0f11cae5038e8ee$export$c9e73fbda7da57b6;
var $a0f11cae5038e8ee$export$5a759dc7a1cfb72a;
"use strict";
var $a0f11cae5038e8ee$var$bundleURL = {};
function $a0f11cae5038e8ee$var$getBundleURLCached(id) {
    var value = $a0f11cae5038e8ee$var$bundleURL[id];
    if (!value) {
        value = $a0f11cae5038e8ee$var$getBundleURL();
        $a0f11cae5038e8ee$var$bundleURL[id] = value;
    }
    return value;
}
function $a0f11cae5038e8ee$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a0f11cae5038e8ee$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $a0f11cae5038e8ee$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a0f11cae5038e8ee$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$a0f11cae5038e8ee$export$bdfd709ae4826697 = $a0f11cae5038e8ee$var$getBundleURLCached;
$a0f11cae5038e8ee$export$c9e73fbda7da57b6 = $a0f11cae5038e8ee$var$getBaseURL;
$a0f11cae5038e8ee$export$5a759dc7a1cfb72a = $a0f11cae5038e8ee$var$getOrigin;

});

parcelRegister("fzFon", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("djKVg")).then(function() {
    return parcelRequire('7GsF7');
});

});
parcelRegister("gZJRp", function(module, exports) {
"use strict";

var $bzWhm = parcelRequire("bzWhm");
module.exports = $bzWhm(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("bzWhm", function(module, exports) {
"use strict";
var $86e02b94fb59de77$var$cachedBundles = {};
var $86e02b94fb59de77$var$cachedPreloads = {};
var $86e02b94fb59de77$var$cachedPrefetches = {};
function $86e02b94fb59de77$var$getCache(type) {
    switch(type){
        case 'preload':
            return $86e02b94fb59de77$var$cachedPreloads;
        case 'prefetch':
            return $86e02b94fb59de77$var$cachedPrefetches;
        default:
            return $86e02b94fb59de77$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $86e02b94fb59de77$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("ic3P0", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("3gumS")).then(function() {
    return parcelRequire('5nqT3');
});

});

parcelRegister("5nhNr", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("2ptar")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("7ILBW"))
]).then(function() {
    return parcelRequire('ij83D');
});

});

parcelRegister("6PBgj", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("2ptar")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("bvXRj"))
]).then(function() {
    return parcelRequire('aowxG');
});

});

parcelRegister("33gcc", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("2ptar")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("eV1cf"))
]).then(function() {
    return parcelRequire('7EWte');
});

});

parcelRegister("fF5HB", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("lXwBR")).then(function() {
    return parcelRequire('6RRpY');
});

});

parcelRegister("dAjdu", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("aD5oV")).then(function() {
    return parcelRequire('hmB5x');
});

});

parcelRegister("1zcWa", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("djwMg")).then(function() {
    return parcelRequire('iyrtk');
});

});

parcelRegister("hCovn", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("boEZ8"))
]).then(function() {
    return parcelRequire('cEFh9');
});

});

parcelRegister("HURcJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("knZtH")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("aNbtx"))
]).then(function() {
    return parcelRequire('ethIe');
});

});

parcelRegister("jsuTD", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("8OCc8")).then(function() {
    return parcelRequire('wv55p');
});

});

parcelRegister("fy45x", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("4KpRe")).then(function() {
    return parcelRequire('i1YpB');
});

});

var $6f34c7616adbc84b$exports = {};


(parcelRequire("fWbcT")).register((parcelRequire("dOGL2")).getBundleURL('kfsQM'), JSON.parse("[\"kfsQM\",\"as-legacy.js\",\"djKVg\",\"newsroom.module.6cdb415d.js\",\"3gumS\",\"statesMap.module.c7f0ecda.js\",\"7ILBW\",\"swiper3.module.6c43e6cc.js\",\"2ptar\",\"swiper3.module.bf925eba.js\",\"bvXRj\",\"plyr.module.bf3fa0c8.js\",\"knZtH\",\"plyr.module.b1ca4229.js\",\"eV1cf\",\"videoGallery.module.2fe5487c.js\",\"lXwBR\",\"scrollytelling.module.fc78c99c.js\",\"aD5oV\",\"faq.module.fe265fa0.js\",\"djwMg\",\"lottie.module.702ec0f0.js\",\"boEZ8\",\"gTime.module.35752766.js\",\"aNbtx\",\"gCarousel.module.e389f78d.js\",\"8OCc8\",\"pagination.module.591ee19c.js\",\"4KpRe\",\"scrollToTop.module.c9906def.js\"]"));


if (document.querySelector(".newsroom")) (parcelRequire("fzFon")).then(function(module) {
    return module.init();
});

if (document.querySelector(".ctype-ce_states_map")) (parcelRequire("ic3P0")).then(function(module) {
    return module.init();
});

if (document.querySelector(".slider-3")) (parcelRequire("5nhNr")).then(function(module) {
    return module.init();
});

if (document.querySelector(".box_inhalt.ext") || document.querySelector(".js-player.local")) (parcelRequire("6PBgj")).then(function(module) {
    return module.init();
});

if (document.querySelector(".ctype-ce_video_gallery")) (parcelRequire("33gcc")).then(function(module) {
    return module.init();
});

if (document.querySelector("aswc-parallax") || document.querySelector("aswc-scroll-blend") || document.querySelector("aswc-vert-img-vid-slider")) (parcelRequire("fF5HB")).then(function(module) {
    return module.init();
});

if (document.querySelector('[data-js="faq-list"]')) (parcelRequire("dAjdu")).then(function(module) {
    return module.init();
});

if (document.querySelector(".lottie-wrapper")) (parcelRequire("1zcWa")).then(function(module) {
    return module.init();
});

if (document.querySelector(".gemtimecont")) (parcelRequire("hCovn")).then(function(module) {
    return module.init();
});

if (document.querySelector(".gem-carousel-outer-wrapper")) (parcelRequire("HURcJ")).then(function(module) {
    return module.init();
});

if (document.querySelector(".news-overview")) (parcelRequire("jsuTD")).then(function(module) {
    return module.init();
});

if (document.querySelector(".scroll-to-top")) (parcelRequire("fy45x")).then(function(module) {
    return module.init();
});
 // =============================================================
 // WHEN COMPLETE
 // functions which are called when the page is fully loaded
 // =============================================================
 // let attempts = 0;
 // const whenComplete = () => {
 //   if (++attempts > 30) return;
 //   if (document.readyState === "complete") {
 //     // --- code ---
 //   } else {
 //     setTimeout(() => whenComplete(), 400);
 //   }
 // };
 // whenComplete();
 // =============================================================
 // STYLES COMPLETE
 // Removes styles_essential when general styles are loaded
 // =============================================================
 // let styleAttempts = 0;
 // const stylesComplete = () => {
 //   if (++styleAttempts > 30) return;
 //   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
 //     document.querySelector("#sess").remove();
 //   } else {
 //     setTimeout(() => stylesComplete(), 300);
 //   }
 // };
 // stylesComplete();

})();
//# sourceMappingURL=as-legacy.js.map
